import { call, put, takeEvery } from 'redux-saga/effects';
import { getScanListApi } from '../api/scanListApi';
import { scanListFailure, scanListSuccess } from '../actions/scanListActions';
import { SCAN_LIST_REQUEST } from '../constants/scanListConstants';

function* fetchScanList(action) {
  try {
    const response = yield call(getScanListApi, action.payload);
    yield put(scanListSuccess(response));
  } catch (error) {
    console.error('Saga: API error:', error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch scan list';
    yield put(scanListFailure(errorMessage));
  }
}

function* scanListSaga() {
  yield takeEvery(SCAN_LIST_REQUEST, fetchScanList);
}

export default scanListSaga;